// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fetchProjectAnalysisStatus } from 'helpers/api'
import { makeBandStatuses } from 'redux/modules/interferenceAnalysis'

// When initializing or updating the Interference Analysis Parameters form,
// we will want to fetch the status for every
// projectId && bandId && analysisTypeId
// meaning, that for every band that is used in a project,
// there will be one to many analysis types to run.
// eg. 'Environment', 'Intrasystem' and 'Earth Station'
// the analysis types are dynamically built based on the analsisTypes
// in interferenceAnalysis redux state

const setParametersStatuses = parameters => async (dispatch, getState) => {
  const projectId = getState().projectSummary.get('projectId')

  const { entities } = await fetchProjectAnalysisStatus(projectId)

  // if there have never been any analyses run for any of the bands that are in
  // this project, then entities will be null. For this scenario, just assign an
  // empty array to simplify the process below
  const projectAnalysisStatuses = entities || []

  return parameters.reduce((a, d, i) => {
    const bandAnalysisStatuses = projectAnalysisStatuses.filter(s => s.bandId === d.bandId)

    const status = dispatch(makeBandStatuses(bandAnalysisStatuses, d.bandId, projectId))

    a.push({
      ...d,
      status,
    })
    return a
  }, [])
}

export default setParametersStatuses
